import Cookies from 'js-cookie';

// 操作cookie
export function getCookie(name) {
  return Cookies.get(name) === 'undefined' ? null : Cookies.get(name);
}

export function setCookie(name, value, params = {}) {
  return Cookies.set(name, value, params);
}

export function removeCookie(name) {
  Cookies.remove(name);
}

// 操作token相关的cookie
const tokenKey = 'x-auth-token';

export function getToken() {
  return Cookies.get(tokenKey);
}

export function setToken(token) {
  // 设置域名 return Cookies.set(tokenKey, token, { domain: '.baidu.com' });
  return Cookies.set(tokenKey, token);
}

export function removeToken() {
  Cookies.remove(tokenKey);
}
